import { connect } from "react-redux";
import { IDType } from "../../../config/types";
import { AppDispatch, RootState } from "../../../store";
import { fetchMatchScreen } from "../../../store/actions/matchActions";

const mapper = (dispatch: AppDispatch) => ({
  loadMatchScreen: (id: IDType) => fetchMatchScreen(dispatch, id)
});

const props = (
  state: RootState,
  prevProps: { matchId: IDType }
) => ({
    screenFromStore: state.match.matchScreens[prevProps.matchId],
    ...prevProps
  });

export const connector = connect(props, mapper);
